import React, { useEffect } from 'react';
import { Chart } from '@antv/g2';

const DailyTotalTransactions = ({ transactionsData }) => {

  const loadPieChart = () => {
    const data = [
      { item: 'Aprobadas', count: transactionsData?.approved?.total, percent: 0.7, color: '#6950E8' },
      { item: 'Rechazadas', count: transactionsData?.rejected?.total, percent: 0.3, color: '#F4A261' },
    ];

    const chart = new Chart({
      container: 'pie-chart',
      autoFit: true,
    });

    chart.coordinate({ type: 'theta', outerRadius: 0.8, innerRadius: 0.5 });
    chart.axis('x', {
      title: false,
      label: false,
      line: {
        style: {
          stroke: 'white',
        },
      },
      tickLine: false,
    });
    chart.axis('y', {
      title: false,
      label: false,
      line: {
        style: {
          stroke: 'white',
        },
      },
      tickLine: false,
    });

    chart
      .interval()
      .data(data)
      .transform({ type: 'stackY' })
      .encode('y', 'percent')
      .encode('color', 'color')
      .scale('color', { type: 'identity' })
      .legend(false)
      .tooltip((data) => ({
        name: data.item,
        value: data.count,
      }));

    chart
      .text()
      // Relative position
      .style('x', '50%')
      .style('y', '50%')
      .style('dy', -25)
      .style('fontSize', 34)
      .style('fill', '#8c8c8c')
      .style('textAlign', 'center');

    chart.render();
  }

  useEffect(() => {
    loadPieChart();
  }, [transactionsData]);
  return (
    <div id="pie-chart" style={{ width: '100%', height: '150px' }}></div>
  )
}

export default DailyTotalTransactions;